import { createSlice } from "@reduxjs/toolkit";

export const influencerSlice = createSlice({
  name: "influencer",
  initialState: {
    isLoading: true,
  },
  reducers: {
    addInfluencer: (state, action) => {
      state.influencer = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { addInfluencer, setLoading } = influencerSlice.actions;
export default influencerSlice.reducer;
